import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useInterviewContext } from '@/features/common/contexts/interview.context';
import PaymentScreen from '@/features/register/pages/PaymentScreen';
import { useBooth } from '@/features/settings/hooks/useBooth';

export default function PaymentPage() {
  const navigate = useNavigate();
  const { createAndSetInterview, onReset } = useInterviewContext();
  const { booth, loading: boothLoading, isBooth } = useBooth();

  const handleSkipPayment = useCallback(async () => {
    try {
      const newInterview = await createAndSetInterview();
      if (newInterview) navigate('/interview', { replace: true });
    } catch {
      // Error already logged in context
    }
  }, [createAndSetInterview, navigate]);

  const handleValidate = useCallback(() => {
    navigate('/payment/proceed', { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (!boothLoading && !(isBooth && booth?.terminalId)) {
      void handleSkipPayment();
    }
  }, [boothLoading, isBooth, booth?.terminalId, handleSkipPayment]);

  if (boothLoading) return null;
  if (!isBooth || !booth?.terminalId) return null;

  return <PaymentScreen onValidate={handleValidate} onCancel={onReset} />;
}
